module.exports = __webpack_public_path__ + "img/zcsb.38bc468b.svg";